import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldToLower extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'tolower');
  }
}
